export default {
  buttons: {
    skip: 'Omitir',
    back: 'Atrás',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
    payment: {
      pending: 'Su pago está siendo procesado...',
      success: '👍 Su pago se procesó correctamente. ¡Gracias!',
      error:
        '⁉️Ha habido un problema con su pago o el procesamiento tarda más de lo esperado. Actualice la página durante 1 minuto; si no, contacte con soporte técnico.',
    },
  },
};
